// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__24AEG","btnRed":"styles_btnRed__FlK57","button":"styles_button__3GCQo"};